$('#sfcc_scheduled_backfill_recurrence').change(function(e) {
  if (e.target.value != 'weekly') {
    $('#sfcc_scheduled_backfill_day').prop( 'disabled', true );
  } else {
    $('#sfcc_scheduled_backfill_day').prop( 'disabled', false );
  }
})
